<script>
  import { useForm } from '@inertiajs/svelte';
  import AppLayout from '../../components/AppLayout.svelte';
  import Card from '../../components/ui/Card.svelte';
  import Field from '../../components/ui/Field.svelte';
  import Button from '../../components/ui/Button.svelte';

  let { calendars = [] } = $props();

  const form = useForm({ name: '', calendar_id: calendars[0]?.id ?? null });

  function submit() {
    form.transform((data) => ({ bin: data })).post('/bins');
  }
</script>

<AppLayout title="New bin">
  {#if calendars.length === 0}
    <Card>
      <div class="text-center py-6">
        <p class="text-secondary-500 mb-4">Create a calendar before adding a bin.</p>
        <Button href="/calendars/new">Create a calendar</Button>
      </div>
    </Card>
  {:else}
    <div class="max-w-md">
      <Card>
        <form onsubmit={(e) => { e.preventDefault(); submit(); }} class="flex flex-col gap-5">
          <Field label="Calendar" id="calendar" error={form.errors.calendar_id}>
            {#snippet children(describedBy)}
              <select id="calendar" class="input" bind:value={form.calendar_id} aria-describedby={describedBy}>
                {#each calendars as cal}
                  <option value={cal.id}>{cal.name}</option>
                {/each}
              </select>
            {/snippet}
          </Field>

          <Field label="Name" id="name" error={form.errors.name}>
            {#snippet children(describedBy)}
              <input id="name" type="text" class="input" bind:value={form.name} placeholder="e.g. Memes" required aria-describedby={describedBy} />
            {/snippet}
          </Field>

          <div class="flex items-center gap-3">
            <Button type="submit" disabled={form.processing}>{form.processing ? 'Creating…' : 'Create bin'}</Button>
            <Button href="/bins" variant="ghost">Cancel</Button>
          </div>
        </form>
      </Card>
    </div>
  {/if}
</AppLayout>
